module.exports = __webpack_public_path__ + "img/title6.4f985e91.png";